import { PortalEditWidgetType, ScreenItem, ScreenType } from '@nx-frontend/shared/types';

export const editWidgetRouter = (widgetType: PortalEditWidgetType): ScreenItem => {
  if (widgetType === PortalEditWidgetType.TOPBAR) {
    return { type: ScreenType.TOPBAR, payload: {} };
  }
  if (widgetType === PortalEditWidgetType.SIDEBAR) {
    return { type: ScreenType.SIDEBAR };
  }
  if (widgetType === PortalEditWidgetType.FOOTER) {
    return { type: ScreenType.FOOTER, payload: {} };
  }
  if (widgetType === PortalEditWidgetType.MAIN) {
    return { type: ScreenType.MAIN };
  }
  if (widgetType === PortalEditWidgetType.LOGO) {
    return { type: ScreenType.ADD_LOGO };
  }
  if (widgetType === PortalEditWidgetType.HERO) {
    return { type: ScreenType.HERO, payload: {} };
  }
  return { type: ScreenType.MAIN };
};
